import React from 'react';
import { Trans } from '@ecg-marktplaats/js-react-i18n';
import { Box } from '@hz-design-system/web-ui';
import dynamic from 'next/dynamic';
import getSuitCSSClasses from '@/utils/getSuitCSSClasses';
import {
  ListingLocationDetails,
  ListingSellerLogo,
  ListingSellerName,
} from '@/client/components/ListingsNew/components';

import Classes from './ListingSellerInfo.module.scss';

const ListingSellerExternalLink = dynamic(
  () => import('@/client/components/ListingsNew/components/ListingSellerExternalLink/ListingSellerExternalLink'),
  { ssr: false },
);

interface ListingSellerInfoProps {
  sellerInformation?: TSellerInformation;
  isVerifiedSeller: boolean;
  location: { label: string; distance?: string };
  isBottomBlock: boolean;
}

const ListingSellerInfo: React.FC<ListingSellerInfoProps> = ({
  sellerInformation,
  isVerifiedSeller,
  location,
  isBottomBlock,
}) => {
  return (
    <Box name="Listing-sellerInfo" as="div" className={Classes['hz-Listing-sellerInfo']}>
      {sellerInformation && (
        <ListingSellerName link={sellerInformation.soiUrl} isVerifiedSeller={isVerifiedSeller}>
          {sellerInformation.sellerName}
        </ListingSellerName>
      )}
      {location && <ListingLocationDetails.Regular location={location} />}

      {sellerInformation?.sellerLogoUrl && <ListingSellerLogo logoUrl={sellerInformation.sellerLogoUrl} />}

      {!sellerInformation?.sellerLogoUrl && sellerInformation?.showWebsiteUrl && (
        <Box as="span" name="Listing-sellerLink" className={Classes['hz-Listing-sellerLink']} suppressHydrationWarning>
          <ListingSellerExternalLink
            url={sellerInformation?.sellerWebsiteUrl}
            className={getSuitCSSClasses({
              namespace: 'hz',
              name: 'TextLink',
            })}
          >
            <Trans tagName="span" i18nKey="listings.visit" />
          </ListingSellerExternalLink>
        </Box>
      )}
    </Box>
  );
};

export default ListingSellerInfo;
